import authService from "@/services/auth/auth.service";
const servicesRoutes = [
  {
    path: "/registries/services",
    name: "ServicesRegistryNewForm",
    component: () => import("@/components/areas/registries/services/ServicesRegistryNewForm.vue"),
    props: (route) => {
      return {
        openDialog: true,
        pathToGoBack: route.query.pathToGoBack,
        tabName: route.query.tabName || 'registry'
      }
    },
    beforeEnter: (to, from, next) => {
      authService.redirectIfLicenseBlocked()
      next()
    }
  },
  {
    path: "/registries/services/:id/edit",
    name: "ServicesRegistryEditForm",
    component: () => import("@/components/areas/registries/services/ServicesRegistryEditForm.vue"),
    props: (route) => {
      return {
        openDialog: true,
        pathToGoBack: route.query.pathToGoBack,
        pathName: route.query.pathName,
        tabName: route.query.tabName || 'registry',
        filters: route.params.filters
      }
    },
  },
  {
    path: "/registries/services/list",
    name: "ServicesRegistryList",
    component: () => import("@/components/areas/registries/services/ServicesRegistryList.vue"),
    props: (route) => {
      return {
        filters: route.params.filters
      }
    }
  },
];

export default servicesRoutes;